import { CloseButton, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React, { useEffect, useRef } from 'react'
import { DefaultModal } from '../../Modals/DefaultModal'
import { ClaimsTabContent } from './ClaimsTabContent'
import { PregnanciesTabContent } from './PregnanciesTabContent'

export const StageReportModal: React.FC<{
  practiceId: string
  isOpen: boolean
  onClose: () => void
}> = ({ practiceId, isOpen, onClose }) => {
  const tabIndexRef = useRef(0)

  useEffect(() => {
    if (!isOpen) tabIndexRef.current = 0
  }, [isOpen])

  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={onClose}
      overlayHeader
      noCloseButton
      size="4xl"
      // contentProps={{ h: '580px' }}
      bodyProps={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', p: 0 }}
      render={() => (
        <Tabs
          display="flex"
          flexDirection="column"
          h="100%"
          defaultIndex={tabIndexRef.current}
          onChange={i => {
            tabIndexRef.current = i
          }}>
          <Flex align="center" borderBottomWidth={1} bg="gray.50" _dark={{ bg: 'gray.800' }}>
            <TabList flex={1} border="none" px={2}>
              <Tab fontWeight="500" fontSize="sm">
                Pregnancies
              </Tab>
              <Tab fontWeight="500" fontSize="sm">
                Claims
              </Tab>
            </TabList>
            <CloseButton mx={2} onClick={onClose} />
          </Flex>
          <TabPanels flex={1} overflow="hidden">
            <TabPanel h="100%" p={0}>
              <PregnanciesTabContent practiceId={practiceId} />
            </TabPanel>
            <TabPanel h="100%" p={0}>
              <ClaimsTabContent practiceId={practiceId} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    />
  )
}
